import { useSelector } from "react-redux";
import { useConfig } from "components/ui";

function useThemeClass() {
  const { themeColor, primaryColorLevel } = useConfig();
  const customPrimaryColor = useSelector((state) => state.theme.customPrimaryColor);

  // If custom color is set, use CSS variables
  if (customPrimaryColor) {
    return {
      ringTheme: "ring-[var(--theme-primary)]",
      borderTheme: "border-[var(--theme-primary)]",
      bgTheme: "bg-[var(--theme-primary)]",
      textTheme: "text-[var(--theme-primary)]",
      themeColorAndLevel: "var(--theme-primary)",
    };
  }

  // Safety fallback for legacy or invalid theme colors
  const safeThemeColor = (themeColor.includes("#") || !themeColor) ? "indigo" : themeColor;

  const isCustom = safeThemeColor.includes("#-");
  const color = isCustom
    ? `${safeThemeColor}`
    : `${safeThemeColor}-${primaryColorLevel}`;

  return {
    ringTheme: `ring-${color}`,
    borderTheme: `border-${color}`,
    bgTheme: `bg-${color}`,
    textTheme: `text-${color}`,
    themeColorAndLevel: color,
  };
}

export default useThemeClass;
